import { observer } from 'mobx-react';
import React, { Component, PureComponent } from 'react';
import { NavLink } from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';
import './client.css'

import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const ClientsBoard = observer(class ClientsBoard extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            clients: [],
            isShowArchive: false
        };

        this.loadClients = this.loadClients.bind(this);
        this.generateClientRows = this.generateClientRows.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChekedChange = this.handleChekedChange.bind(this);
    }

    componentDidMount() {
        this.loadClients();
    }

    handleChange = name => evt => {
        this.setState({[name]: evt.target.value});
    }

    handleChekedChange = name => evt => {
        this.setState({ [name]: evt.target.checked }, () => this.loadClients());
    }

    loadClients() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Account/list?name=' + this.state.name + '&isShowArchive=' + this.state.isShowArchive, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ clients: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    generateClientRows() {
        return (
            <div className="client-board">
                <div className="search-button-block">
                    <div className="quick-filter-panel clearfix">
                        <div className="quick-filter-item">
                            <FormControl>
                                {false && <IconButton
                                    className="search-button-menu-icon"
                                    aria-label="menu"
                                    onClick={(evt) => this.setState({ "anchorEl": evt.currentTarget })}
                                    size="large">
                                    <MenuIcon />
                                </IconButton>}
                                <Input
                                    id="adornment-search"
                                    className="search-filter-input"
                                    type='text'
                                    value={this.state.name}
                                    //placeholder={this.state.searchPlaceHolder}
                                    onChange={(evt) => { this.handleChange('name')(evt); }}
                                    onKeyPress={(event) => (event.key === 'Enter') && this.loadClients()}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton aria-label="начать поиск" onClick={this.loadClients} size="large">
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </div>
                        <div className="quick-filter-item">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.isShowArchive}
                                        onChange={this.handleChekedChange('isShowArchive')}
                                        value="isShowArchive"
                                        inputProps={{
                                            'aria-label': 'primary checkbox',
                                        }}
                                    />}
                                label="Отображать архивные"
                            />
                        </div>
                    </div>
                </div>
                {this.state.clients.map(c => <div className="client-row">
                    <NavLink tag={RRNavLink} className="text-dark client-header" style={{ background: c.accountColor }} className={(navData) => navData.isActive ? "opened-link" : ""} to={"/client?id=" + c.id}>{c.name}</NavLink>
                    <div>Активные проекты: {c.activeProjectCount}</div>
                    <div>Всего проектов: {c.projectCount}</div>
                    {c.loyaltyLevel && <div>Уровень лояльности: {c.loyaltyLevel}</div>}
                </div>)}
            </div>
        );
    }

    render() {
        return (
            <div>
                <h2>Наши любимые клиенты</h2>
                {this.generateClientRows()}
            </div>
        );
    }
});

export default ClientsBoard;